import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { updateDsr } from '../actions/dsr-actions'
import { redirectToNewPage } from '../../global/helpers/global-helpers'
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function DsrDeleteModal({ dsrId, handleCloseModal, isMobileView, updateDsrOutcome, updateDsr }) {

  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus, sourceEvent } = updateDsrOutcome || {};

      if (updateDsrStatus && sourceEvent === "delete-dsr") {
        redirectToNewPage(`/home`)
      }
    }

  }, [updateDsrOutcome, dsrId]);

  const handleClickUnpublishButton = () => {
    setShowLoader(true);
    updateDsr({ dsrId, status: 'deleted', sourceEvent: "delete-dsr" })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {

      return (
        <Flex justify='flex-start' px='1.5em' mt='1em' w='100%'>
          <Box w='100%'>
            <Box w="100%" my="1em" color='brandDark.500'>
              <Box fontSize='0.875em'>
                The Room will be removed for good, and will no longer be available for all members. Go ahead?
              </Box>
            </Box>

            <Flex w='100%' mt='1em'>
              <Flex my='1em' justify='flex-end' w='100%'>
                <LaunchdeckButton name='showRevertToDraft' w={isMobileView && '100%'} label='Yes, delete Room' fontSize='0.875em' py='0.4em' bg='brandPink.500' color='white' onClick={() => handleClickUnpublishButton()} />
              </Flex>
            </Flex>
          </Box>
        </Flex>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={'Delete Room'}
      handleCloseModal={handleCloseModal}
      showModal={true}
      maxW='35em'
      bannerBg='brandPink.500'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrDeleteModal));
